module.exports = __webpack_public_path__ + "static/2-09bbc1841aea9384164a2c522b84bcec.jpg";